/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * How Compare groups each period: days, Sunday-to-Saturday weeks, months.
 */
export enum CompareBy {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
}
